<script>
import UserExpandableGiftCardListVue from 'App/users/components/tables/UserExpandableGiftCardList.vue';

export default {
  name: 'UserBoProductList',
  extends: UserExpandableGiftCardListVue,
  data: () => ({
    hideTableBottom: false,
    category: 'BOLETO',
    preHeaders: [
      {
        text: 'Integrador',
        value: 'produtoServicoIntegrador.integrador.nomIntegrador',
      },
    ],
  }),
  methods: {
    makeDefaultParams(params = {}) {
      return {
        lojaId: this.storeId,
        produtoServicoCategoria: this.category,
        ...params,
      };
    },
  },
};
</script>
